<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      ref="verticalNavMenu"
      v-model="isVerticalNavMenuActive"
      v-hammer:swipe="onMenuSwipe"
      class="v-nav-menu items-no-padding"
      style="overflow: unset !important"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hidden-background="clickNotClose"
      :reduce="reduce"
    >
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <!-- Header -->
        <div slot="header" class="header-sidebar flex items-center justify-between">
          <!-- Logo -->
          <router-link tag="div" class="vx-logo-text cursor-pointer inline-flex" to="/">
            <!-- Need to do this for 'svg-inline' to work for our logo -->
            <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   height="124.8"
   width="480"
   inkscape:version="1.0 (4035a4f, 2020-05-01)"
   sodipodi:docname="prisma.svg"
   id="svg162"
   xml:space="preserve"
   viewBox="0 0 480 124.8"
   y="0px"
   x="0px"
   version="1.1" v-bind:class="'logo-platform w-8/12 fill-primary'" v-bind:svg-inline="''" v-bind:style="'max-height: 44px'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><metadata
   id="metadata168"><rdf:RDF><cc:Work
       rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
         rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work></rdf:RDF></metadata><defs
   id="defs166" /><sodipodi:namedview
   fit-margin-bottom="0"
   fit-margin-right="0"
   fit-margin-left="0"
   fit-margin-top="0"
   inkscape:current-layer="LOGO"
   inkscape:window-maximized="1"
   inkscape:window-y="23"
   inkscape:window-x="0"
   inkscape:cy="2.1954604"
   inkscape:cx="444.93191"
   inkscape:zoom="0.96375"
   showgrid="false"
   id="namedview164"
   inkscape:window-height="1312"
   inkscape:window-width="2560"
   inkscape:pageshadow="2"
   inkscape:pageopacity="0"
   guidetolerance="10"
   gridtolerance="10"
   objecttolerance="10"
   borderopacity="1"
   bordercolor="#666666"
   pagecolor="#ffffff" />

<g
   transform="translate(-160,-356.3)"
   id="LOGO">
	<g
   id="g123">
		<g
   id="g101" class="prisma">
			<path
   id="path89"
   class="prisma-letter p"
   d="M 185.4,357.5 H 160 v 78 h 9.5 v -27.1 h 15.9 c 16.8,0 26.9,-10.6 26.9,-25.5 0,-14.9 -10.1,-25.4 -26.9,-25.4 z m -0.8,41.9 h -15.2 v -33.2 h 15.2 c 11,0 18,5.6 18,16.6 0,11 -7,16.6 -18,16.6 z" />
			<path
   id="path91"
   class="prisma-letter r"
   d="m 296.8,382.8 c 0,-14.8 -10.1,-25.4 -26.6,-25.4 H 245 v 78 h 9.5 v -27.7 h 15.7 0.9 l 18.2,27.7 h 10.3 l -19.5,-29.1 c 10.6,-3.2 16.7,-11.8 16.7,-23.5 z m -27.7,16.6 h -14.6 v -33.2 h 14.6 c 11,0 18,5.6 18,16.6 0,11 -7,16.6 -18,16.6 z" />
			<rect
   id="rect93"
   class="prisma-letter i"
   height="78"
   width="9.5"
   y="357.5"
   x="331.29999" />
			<path
   id="path95"
   class="prisma-letter s"
   d="m 403.4,391.7 -5.3,-2.1 c -9.2,-3.6 -12.5,-7.9 -12.5,-13.4 0,-7 5.7,-11.2 13.2,-11.2 7.9,0 13,4.3 16,11.3 l 7.3,-3.7 c -3.1,-8.5 -10.7,-16.3 -23.5,-16.3 -12.6,0 -22.4,7.7 -22.4,19.8 0,10.1 6.9,16.5 18.4,21.1 l 5.2,2 c 9.1,3.6 14.8,7.1 14.8,15.2 0,8.9 -7.1,13.4 -15.4,13.4 -9.3,0 -16.2,-5.7 -18.4,-13.8 l -7.8,3.6 c 2.6,11.2 13,19 26.2,19 13.1,0 25.1,-7.7 25.1,-22.1 -0.1,-12 -8.1,-17.7 -20.9,-22.8 z" />
			<polygon
   id="polygon97"
   class="prisma-letter m"
   points="456.4,357.5 456.4,435.5 465.8,435.5 465.8,376.2 466.4,376.2 493.6,435.5 500.8,435.5 528,376.2 528.6,376.2 528.6,435.5 538,435.5 538,357.5 527.5,357.5 497.1,423.3 466.9,357.5 " />
			<polygon
   id="polygon99"
   class="prisma-letter a"
   points="598.6,426.9 602,435.5 629.8,435.5 631.2,435.5 640,435.5 609,357.5 599.6,357.5 568.6,435.5 578.8,435.5 604.3,369.6 626.5,426.9 " />
		</g>
		<g
   id="g121" class="by-alquant">
			<polygon
   id="polygon103"
   points="473.8,468.9 474.7,471.1 477.2,476.6 479.7,476.6 470.1,455.5 467.9,455.5 458.4,476.6 460.8,476.6 463.3,471.1 464.2,468.9 469,458.2 "
   class="st1" />
			<polygon
   id="polygon105"
   points="490.7,474.4 490.7,455.6 488.4,455.6 488.4,476.6 502.5,476.6 502.5,474.4 "
   class="st1" />
			<path
   id="path107"
   d="m 531.3,469.9 c 0.4,-1.2 0.6,-2.5 0.6,-3.8 0,0 0,0 0,0 0,0 0,0 0,-0.1 0,-1.4 -0.3,-2.8 -0.8,-4.1 -1,-2.6 -3,-4.7 -5.5,-5.8 -1.4,-0.6 -2.9,-0.9 -4.4,-0.9 -4.4,-0.1 -8.4,2.6 -10,6.7 -0.5,1.3 -0.8,2.7 -0.8,4.1 v 0.1 c 0,1.4 0.3,2.8 0.8,4.1 0.5,1.3 1.2,2.5 2.2,3.4 1,1 2.1,1.8 3.4,2.4 1.4,0.6 2.9,0.8 4.3,0.8 h 0.1 v -2.2 c -1.1,0 -2.3,-0.2 -3.3,-0.7 -2,-0.9 -3.6,-2.5 -4.4,-4.6 -0.4,-1.1 -0.6,-2.2 -0.6,-3.4 v 0.1 c 0,-1.1 0.2,-2.3 0.6,-3.4 0.4,-1 1,-1.9 1.7,-2.7 0.7,-0.8 1.6,-1.4 2.6,-1.8 1,-0.4 2.2,-0.7 3.3,-0.6 1.1,0 2.3,0.2 3.3,0.7 1,0.4 1.9,1.1 2.6,1.9 0.7,0.8 1.3,1.7 1.7,2.7 0.4,1.1 0.6,2.2 0.6,3.4 v 0.1 c 0,1 -0.2,2 -0.5,2.9 -0.3,0.9 -0.8,1.7 -1.3,2.5 l -3.8,-3.5 -1.6,1.8 3.9,3.3 1.8,1.5 2.8,2.5 1.6,-1.8 -2.8,-2.3 c 0.8,-1 1.4,-2.1 1.9,-3.3 z"
   class="st1" />
			<path
   id="path109"
   d="m 556.2,467.8 c 0,2.3 -0.6,4 -1.7,5.2 -2.7,2.3 -6.7,2.3 -9.3,-0.1 -1.1,-1.2 -1.7,-3 -1.7,-5.2 v -12.1 h -2.4 v 12.2 c 0,1.3 0.2,2.7 0.6,3.9 0.4,1.1 1,2.1 1.8,2.9 0.8,0.8 1.7,1.4 2.8,1.7 1.1,0.4 2.3,0.6 3.6,0.6 1.2,0 2.4,-0.2 3.6,-0.6 1,-0.4 2,-1 2.8,-1.8 0.8,-0.8 1.4,-1.8 1.8,-2.9 0.4,-1.3 0.7,-2.7 0.6,-4 v -12 h -2.4 v 12.2 z"
   class="st1" />
			<polygon
   id="polygon111"
   points="582.3,468.9 583.2,471.1 585.6,476.6 588.2,476.6 578.6,455.5 576.4,455.5 566.9,476.6 569.3,476.6 571.8,471.1 572.7,468.9 577.5,458.2 "
   class="st1" />
			<polygon
   id="polygon113"
   points="614.6,476.6 614.6,455.6 612.3,455.6 612.3,472.4 599.1,455.6 596.9,455.6 596.8,476.6 599.1,476.6 599.1,459.4 612.7,476.6 "
   class="st1" />
			<polygon
   id="polygon115"
   points="623.5,457.8 630.6,457.8 630.6,476.6 633,476.6 633,457.8 640,457.8 640,455.6 623.5,455.6 "
   class="st1" />
			<path
   id="path117"
   d="m 419.4,463.1 c -2.4,0 -4.2,1.3 -4.9,2.7 h -0.1 v -7.2 h -2.1 v 17.7 h 2.1 v -2.4 h 0.1 c 0.6,1.4 2.4,2.7 4.9,2.7 3.2,0 6.4,-2.3 6.4,-6.7 -0.1,-4.5 -3.3,-6.8 -6.4,-6.8 z m -0.4,11.5 c -2.3,0 -4.6,-1.6 -4.6,-4.8 0,-3.2 2.3,-4.8 4.6,-4.8 2.3,0 4.6,1.6 4.6,4.8 0,3.2 -2.3,4.8 -4.6,4.8 z"
   class="st1" />
			<polygon
   id="polygon119"
   points="439.8,463.3 435.4,473.7 431.1,463.3 428.9,463.3 434.4,476.2 432.3,481.1 434.3,481.1 436.4,476.3 441.9,463.3 "
   class="st1" />
		</g>
	</g>
</g>
</svg>
          </router-link>

          <!-- Menu Buttons -->
          <div class="flex items-center">
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                class="m-0 cursor-pointer"
                @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)"
              />
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <div v-show="showShadowBottom" class="shadow-bottom" />

        <!-- Menu Items -->
        <component
          :is="scrollbarTag"
          ref="verticalNavMenuPs"
          :key="$vs.rtl"
          class="scroll-area-v-nav-menu pt-2"
          :class="{ 'deactivated-scrollbar': deactivateScrollbar }"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
        >
          <template v-for="(item, index) in menuItemsUpdated">
            <!-- Nav-Group -->
            <template>
              <v-nav-menu-group
                v-if="item.submenu"
                :key="`group-${index}`"
                :open-hover="openGroupHover"
                :group="item"
                :group-index="index"
                :open="isGroupActive(item)"
                :top-header="true"
              />
              <v-nav-menu-item
                v-else
                :key="`group-${index}`"
                class="mb-4"
                :index="index"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon"
                :slug="item.slug"
                :target="item.target"
                :meta="item.meta"
                :linked-urls="item.linkedUrls"
                :on-click-function="item.onClickFunction"
                ><span class="truncate" :class="[{ 'font-bold underline': item.featured }]">{{
                  item.name
                }}</span></v-nav-menu-item
              >
            </template>
          </template>
        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      v-hammer:swipe="onSwipeAreaSwipe"
      class="v-nav-menu-swipe-area"
    />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import { hasAnyRoles } from "@/acl";
import exports from "@/assets/scss/exports.module.scss";
import config from "@/config/alquant";

import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";

export default {
  name: "VNavMenu",
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
  },
  props: {
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
    deactivateScrollbar: { type: Boolean, default: false },
  },
  data: () => ({
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
    flagDefaultOpened: true,
  }),
  computed: {
    logoPath() {
      return config.logoPath;
    },
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        if (path === "/" && item.name === "Indicators" && this.shouldBeDefaultOpen()) {
          return true;
        }
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined;
        let open = false;

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              // we say that a sub menu is open if
              //  a url linked to the sub menu is open
              const isLinkedUrlsOpen = item.linkedUrls && item.linkedUrls.includes(path);
              //  or the url of the submenu itself is open
              const isUrlOpen = item.url && (path === item.url || routeParent === item.slug);
              if (isLinkedUrlsOpen || isUrlOpen) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {
      // Note: We need to use a clone, all those index and `findIndex` because we cannot
      // assume any order on the elements.
      const clone = this.navMenuItems.slice();
      for (const item of this.navMenuItems) {
        // Check if user has authorization to view this group of menu items.
        let sectionAuthorized = true;
        const itemNeedsAuthorization = item.meta && item.meta.authorize;
        if (itemNeedsAuthorization) {
          sectionAuthorized = hasAnyRoles(item.meta.authorize);
          if (!sectionAuthorized) {
            // Remove unauthorized section.
            const i = clone.findIndex((ix) => ix.name === item.name);
            clone.splice(i, 1);
          }
        }
      }
      return clone;
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      /*
      When a route changes, we might have a lot of the dropdown open,
      and as we are closing them, the size of the perfect scroll bar
      element isn't modified, and thus we need to "update" it.
      Note that we put 150 ms because the closing happens in 50 ms,
      and we need the items to be closed to know how much to update.
      */
      if (this.scrollbarTag == "VuePerfectScrollbar") {
        const scrollBar = this.$refs["verticalNavMenuPs"];
        setTimeout(() => {
          scrollBar.update();
        }, 150);
      }
    },
    reduce(val) {
      const verticalNavMenuWidth = val
        ? "reduced"
        : this.$store.state.windowWidth < 1200
          ? "no-nav-menu"
          : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  },
  methods: {
    shouldBeDefaultOpen() {
      if (this.flagDefaultOpened) {
        this.flagDefaultOpened = false;
        return true;
      }
      return false;
    },
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
      // Swipe Left
      else if (event.direction === 2 && !this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
      // Swipe Left
      else if (event.direction === 2 && this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scrollEl = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scrollEl.scrollTop > 0 ? true : false;
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", verticalNavMenuItemsMin);

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced ? "reduced" : "default";
          this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },
    getColorFromName(colorName) {
      return exports[`colors-${colorName}`];
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

.deactivated-scrollbar {
  overflow: unset !important;
}
</style>
